document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ embroidery.js loaded (Dawn AJAX compatible version)");

  function insertEmbroideryField() {
    const productForm = document.querySelector("product-form form, form[action*='/cart/add']");
    if (!productForm) return;

    const embroideryGroup = Array.from(document.querySelectorAll(".product-form__input"))
      .find(el => el.querySelector("legend")?.innerText.toLowerCase().includes("hand embroidery"));
    if (!embroideryGroup) return;

    if (!document.getElementById("embroidery-section")) {
      const embroideryHTML = `
        <div id="embroidery-section" class="product-form__input" style="margin-top:1.2rem; display:none;">
          <label for="pet-name" class="field__label" style="font-size:1.4rem;font-weight:500;">
            Pet’s Name 宠物名字：
          </label>
          <input
            type="text"
            id="pet-name"
            placeholder="e.g. Mochi, Luna, 小白"
            class="field__input"
            style="font-size:1.3rem; padding:0.8rem; border:1px solid #ccc; border-radius:6px; width:100%;"
          >
          <p style="font-size:1.2rem;margin-top:0.4rem;color:rgba(0,0,0,0.7);">
            Personalized with your pet’s name – stitched with love 💛
          </p>
        </div>`;
      embroideryGroup.insertAdjacentHTML("afterend", embroideryHTML);
      console.log("🧵 Pet name input added below Hand Embroidery group");
    }

    const section = document.getElementById("embroidery-section");
    const yesButton = embroideryGroup.querySelector('input[type="radio"][value*="Yes" i]');
    const noButton = embroideryGroup.querySelector('input[type="radio"][value*="No" i]');
    const input = document.getElementById("pet-name");
    if (!yesButton || !noButton || !section || !input) return;

    const toggle = () => (section.style.display = yesButton.checked ? "block" : "none");
    yesButton.addEventListener("change", toggle);
    noButton.addEventListener("change", toggle);
    toggle();

    // ✅ 核心修复：劫持 Shopify AJAX 提交请求
    document.addEventListener("submit", (event) => {
      const form = event.target;
      if (!form.action.includes("/cart/add")) return;

      // 若有宠物名 + 选择 Yes，动态注入属性字段
      const existingInput = form.querySelector('[name="properties[Pet\'s Name]"]');
      if (yesButton.checked && input.value.trim() !== "") {
        if (!existingInput) {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = "properties[Pet's Name]";
          hiddenInput.value = input.value.trim();
          form.appendChild(hiddenInput);
          console.log("✨ Added Pet’s Name property to form:", input.value.trim());
        } else {
          existingInput.value = input.value.trim();
        }
      }
    });
  }

  setInterval(insertEmbroideryField, 1000);
});
